
























































































import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import { DateTime } from "luxon";
import { validationMixin } from "vuelidate";

import { Event } from "@api/models/Event";
import { MultiLanguageObject } from "@api/models/objects/MultiLanguageObject";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { FileRepository } from "@api/repositories/FileRepository";

import { getLSKey as getTimezoneLSKey, getTimezoneFromLS } from "@share/session-edit/helpers/timeZoneHelper";
import { ObjectsService } from "@share/common/services/ObjectsService";
import { createLanguageService, LanguagesService } from "@share/common/services/LanguagesService";
import { createValidationObjectForMultiLanguage } from "@share/common/helpers/ValidationObjectCreator";
import { validationRules } from "@share/event-edit/data";
import { ObjectResetter } from "@share/common/helpers/ObjectResetter";
import { getImageUrl } from "@common/ImageUrlHelper";

import FormGroup from "@share/common/form/form-group/FormGroup.vue";
import ControlWrapperBorderless from "@share/common/ControlWrapperBorderless.vue";
import DatePickerInput from "@share/common/form/form-controls/date/date-picker/DatePickerInput.vue";
import TextSelect from "@share/common/form/form-controls/select/variations/text-select/TextSelect.vue";
import PartnersList from "@share/common/partners-list/PartnersList.vue";
import LangSelector from "@share/common/controls/lang-selector/LangSelector.vue";
import EventEditPartners from "@share/event-edit/components/EventEditPartners.vue";
import AddPartnerButton from "@share/event-edit/components/AddPartnerButton.vue";
import DragNDrop, { FilesPayload } from "@share/common/form/form-controls/file/DragNDrop.vue";
import EventEditFileUpload from "@share/event-edit/components/EventEditFileUpload.vue";

import { OnSaveObserver } from "@share/event-edit/observers/OnSaveObserver";
import { FileChangeObserver } from "@share/event-edit/observers/FileChangeObserver";
import { OnResetObserver } from "@share/event-edit/observers/OnResetObserver";
import { AsyncComponentFactory } from "vue/types/options";
import PartnerListFormStub from "@share/catalog/components/list/PartnerListFormStub.vue";
import Overlay from "@share/common/Overlay.vue";
import { PartnerIdsChangedObserver } from "@share/event-edit/observers/PartnerIdsChangedObserver";
import { initDataLoader } from "@share/event-edit/helpers/InitDataLoader";
import { UnloadService } from "@share/common/services/unloadService/UnloadService";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import { ProgramDataHelper } from "@share/program/helpers/ProgramDataHelper";

// @ts-ignore
const PartnerCreate: AsyncComponentFactory = () => {
    return {
        component: import( /* webpackChunkName: "partnerCreate" */ '@share/catalog/components/admin/PartnerCreate.vue'),
        delay: 120,
        loading: PartnerListFormStub
    }
}

@Component({
    name: "EventEdit",
    components: {
        BounceSpinner,
        Overlay,
        EventEditFileUpload,
        DragNDrop,
        AddPartnerButton,
        EventEditPartners,
        PartnersList, TextSelect, LangSelector,
        DatePickerInput, ControlWrapperBorderless, FormGroup,
        PartnerCreate
    },
    validations() {
        return  (this as EventEdit).validationRules;
    }
})
export default class EventEdit extends Mixins(validationMixin) {
    @Prop() programDataHelper: ProgramDataHelper;
    @Prop({ required: true }) eventId: string;

    fileValue: FilesPayload = [];
    isInitialized = false;
    showPartnerCreate = false;
    languagesService: LanguagesService | null = null;
    event: MultiLanguageObject<Event> | null = null;
    objectsService: ObjectsService | null = null;
    currentTimeZone = getTimezoneFromLS(getTimezoneLSKey(this.backend));
    schemaId = '';
    onSaveObserver: OnSaveObserver | null = null;
    fileChangeObserver: FileChangeObserver | null = null;
    onResetObserver: OnResetObserver | null = null;
    objectResetter: ObjectResetter | null = null;
    onPartnerIdsChanged: PartnerIdsChangedObserver | null = null;
    unloadService: UnloadService | null = null;

    get $vLocalized() {
        if (this.languagesService?.selected && this.$v.event) {
            return (this.$v as any).event.data[this.languagesService?.selected || this.languagesService?.baseLanguage];
        }

        return this.$v;
    }

    get $vBaseLanguage() {
        if (this.languagesService?.baseLanguage) {
            return (this.$v as any).event.data[this.languagesService.baseLanguage];
        }
        return this.$v;
    }

    get backend() {
        return this.$store.state.session.backend;
    }

    get needToReset() {
        return this.objectResetter?.needToReset;
    }

    get validationRules() {
        if (!this.event) {
            return {};
        }

        return createValidationObjectForMultiLanguage('event', validationRules, this.event)
    }

    get invalidLanguages() {
        if (!this.objectResetter?.needToReset) {return [];}

        const invalidLanguages: string[] = [];

        for (const key in this.$v.event.data) {
            if (this.$v.event.data[key]?.$dirty && this.$v.event.data[key]?.$error) {
                invalidLanguages.push(key);
            }
        }

        return invalidLanguages;
    }

    get hasStageFile() {
        return !!(this.event?.base?.stageFileId);
    }

    get styles() {
        const result: Record<string, string> = {};

        if (this.hasStageFile) {
            result['background-image'] = `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${getImageUrl(this.backend, this.event?.base?.stageFileId)})`;
        }

        return result;
    }

    get tagsSchemaId() {
        return this.$store.getters['events/tagsSchemaId'](this.partnerSchemaId);
    }

    get partnerSchemaId() {
        return this.$store.state.events.exhibitions.schemaId;
    }

    @Watch('event', {deep: true})
    onDataChange(newValue: any, oldValue: any) {
        if (oldValue == null || this.objectResetter?.needToReset) {
            return;
        }

        if (this.objectResetter) {
            this.objectResetter.needToReset = true;
        }
    }

    async mounted() {
        this.objectsService = new ObjectsService(
            this.$repositories.get<ObjectRepository>(RepositoryFabric.OBJECT),
            this.$store
        );
        this.languagesService = await createLanguageService(this.$store);
        this.schemaId = process.env.VUE_APP_EVENTS_SCHEMA! || 'Events';

        this.onSaveObserver = new OnSaveObserver(this);
        this.fileChangeObserver = new FileChangeObserver(this.$repositories.get<FileRepository>(RepositoryFabric.FILE), this);

        const schemaSettings = Event.getSchemaSettings(this.schemaId);

        const [event] = await initDataLoader(this, schemaSettings);

        if (event) {
            this.event = new MultiLanguageObject<Event>(this.languagesService, event, schemaSettings);
            this.objectResetter = new ObjectResetter(this.event.data);
            this.onResetObserver = new OnResetObserver(this.objectResetter);
            this.onPartnerIdsChanged = new PartnerIdsChangedObserver(this.event);
            this.unloadService = new UnloadService(this, 'needToReset', this.$t('agenda.form.goBackConfirmation').toString());
        }

        this.isInitialized = true;
    }

    updateDate(value: DateTime, key: string) {
        if (this.event?.base[key] && value.isValid) {
            this.event.base[key] = value;
        }
    }

    async beforeDestroy() {
        this.onSaveObserver?.unsubscribe();
        this.onResetObserver?.unsubscribe();
        this.unloadService?.unsubscribe();
    }
}
